import { useAuth } from "@/hooks/useAuth"

export type Role = "owner" | "admin" | "member" | "viewer"

const ROLE_HIERARCHY: Record<Role, number> = {
  owner: 4,
  admin: 3,
  member: 2,
  viewer: 1,
}

export function useRole() {
  const { user } = useAuth()

  // cognito:groups can be string[] or comma-separated string depending on OIDC library.
  // user_groups は OCI Identity Domains のカスタムクレーム（同内容・OCI 構成で使用）。
  const groupsClaim = user?.profile?.["cognito:groups"] ?? user?.profile?.["user_groups"] ?? []
  const groups: string[] = Array.isArray(groupsClaim)
    ? groupsClaim
    : typeof groupsClaim === "string"
      ? groupsClaim.split(",").map((g: string) => g.trim())
      : []

  const role: Role = groups.includes("owner")
    ? "owner"
    : groups.includes("admin")
      ? "admin"
      : groups.includes("member")
        ? "member"
        : "viewer"

  const hasMinimumRole = (required: Role) =>
    ROLE_HIERARCHY[role] >= ROLE_HIERARCHY[required]

  return {
    role,
    groups,
    isOwner: role === "owner",
    isAdmin: hasMinimumRole("admin"),
    isMember: hasMinimumRole("member"),
    hasMinimumRole,
  }
}
